import { goBack } from 'react-router-redux';

export default function onGoBack() {
  return goBack();
}
